<template>
	<div class="d-flex align-items-center">
		<div>
			<Select
				v-model="type"
				:options="typeOptions"
				@input="emitChangeEvent"
			/>
		</div>
		<div v-if="dateEligible" class="ml-3">
			<DatePicker
				v-model="date"
				:years-in-past="40"
				:years-in-future="20"
				@input="emitChangeEvent"
			/>
		</div>
	</div>
</template>

<script>
import {isDefined, valueIfNotUndefined} from "@/helper/Value";
import DatePicker from "@/vue/common/form/DatePicker";
import Select from "@/vue/common/form/Select";

const TYPE_UNLIMITED = 'unlimited';
const TYPE_LIMITED = 'limited';

export default {

	components: {
		DatePicker,
		Select,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		const date = valueIfNotUndefined(this.value);

		let type = undefined;

		if (date !== undefined)
		{
			type = date === null ? TYPE_UNLIMITED : TYPE_LIMITED;
		}

		return {
			type,
			date,
		}
	},

	computed: {
		typeOptions ()
		{
			return [
				{value: TYPE_UNLIMITED, text: 'zeitlich unbeschränkt'},
				{value: TYPE_LIMITED, text: 'zeitlich befristet bis'},
			];
		},
		dateEligible ()
		{
			return this.type === TYPE_LIMITED;
		},
		valid ()
		{
			return this.type === TYPE_UNLIMITED || isDefined(this.date);
		}
	},

	methods: {
		emitChangeEvent ()
		{
			let data = undefined;

			if (this.valid)
			{
				data = this.dateEligible ? this.date : null;
			}

			this.$emit('input', data);
		},
	}
}
</script>
